module.exports = __webpack_public_path__ + "static/media/cover-desktop-1220x150@2x.37330bff.jpg";